/* -----------------------------------------------------------------------
 * <copyright company="Microsoft Corporation">
 *   Copyright (c) Microsoft Corporation.  All rights reserved.
 * </copyright>
 * ----------------------------------------------------------------------- */

import { BlobServiceClient, ContainerClient } from "@azure/storage-blob";

import { config } from "../../services/config";
import { getURLParams } from "../util";

const containerName = process.env.REACT_APP_BLOB_CONTAINER_NAME || "";

const createBlobInContainer = async (
  containerClient: ContainerClient,
  file: File
) => {
  const blobClient = containerClient.getBlockBlobClient(file.name);

  const options = {
    blobHTTPHeaders: { blobContentType: file.type },
    metadata: {
      CandidateId: getURLParams().candidateId,
      ReferenceId: getURLParams().referenceId,
    },
    tags: {
      Status: `Pending_${getURLParams().referenceId}`,
      Timestamp: new Date(new Date().toUTCString()).toJSON(),
    },
  };

  await blobClient.uploadData(file, options);
};

export const uploadFileToBlob = async (
  file: File | null,
  sasToken: string
): Promise<void> => {
  if (!file) return;
  const blobService = new BlobServiceClient(
    `${config.api.blobEndPoint}/${sasToken}`
  );

  const containerClient: ContainerClient =
    blobService.getContainerClient(containerName);

  await createBlobInContainer(containerClient, file);
};
